import { Outlet, RouteObject } from "react-router-dom";
import CandidateRoute from "./candidate";
import EnterpriseRoute from "./enterprise";
import Protected from "@/pages/protected";
import ApprenticeshipPicklistRoute from "./picklist";
import ApprenticeshipMapRoute from "./map";
import ApprenticeshipStudentRoute from "./student";
import ApprenticeshipTaskRoute from "./task";
import ScrapingRoute from "./scraping";
import MatchRoute from "./match";
import EnterpriseGroupRoute from "./enterprise-group";
const ApprenticeshipRoute: RouteObject = {
    path: "alternance",
    element: (
        <Protected>
            <Outlet />
        </Protected>
    ),
    children: [
        CandidateRoute,
        EnterpriseRoute,
        EnterpriseGroupRoute,
        ApprenticeshipMapRoute,
        ApprenticeshipPicklistRoute,
        ApprenticeshipStudentRoute,
        ApprenticeshipTaskRoute,
        MatchRoute,
        ScrapingRoute
    ]
};

export default ApprenticeshipRoute;
